import React, { useState } from 'react'
// import xlsxIcon from '../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/xlsxIcon.svg'
import xlsxIcon from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/xlsxIcon.svg'
import { Row, Col, Button, Card, Label, Input } from "reactstrap";
import ReactQuill from 'react-quill';
import { Editor, SetInnerHtmlWithClassReplacement } from '../../../../../../../../Utils/Constants';
import CustomModal from '../../../../../../../Components/Modals/CustomModal';

function AssetsCommentsPopup(props) {
    const [isExpanded, setIsExpanded] = useState(false)
    const [expandedNote, setExpandedNote] = useState(null);
    const handleQuillChange = (value, delta, source, editor) => {
        const plainText = editor.getText().trim();
        props.setNote(plainText === '' ? '' : value);
    };    

    const replaceNoteText = SetInnerHtmlWithClassReplacement(props.noteList);

    const openNoteModal = (fullMessage) => {
        setExpandedNote(fullMessage);
        setIsExpanded(true);
    };

    const ReadMore = ({ htmlContent, maxLength, onReadMoreClick }) => {
        const isLong = htmlContent &&htmlContent.length > maxLength;
        const truncatedContent = isLong ? htmlContent.substring(0, maxLength) + '...' : htmlContent;

        return (
            <div>
                <span
                    className="issue-description-set d-flex flex-wrap"
                    dangerouslySetInnerHTML={{ __html: truncatedContent }}
                />
                {isLong && (
                    <span
                        style={{ fontSize: '13px' }}
                        className="cursor-pointer d-flex justify-content-end text-primary"
                        onClick={() => onReadMoreClick(htmlContent)}
                    >
                        ....Read More
                    </span>
                )}
            </div>
        );
    };

    return (
        <Card className="card-of-problemarea p-3">
        <Row>
           <Col md={7} className="p-0">
                {(() => {
                    if (props.demoImage) {
                        return (
                            <div className="xlx-file">
                                <img src={xlsxIcon} alt="XLSX Icon" />
                                <h5><b>Preview Not Available</b></h5>
                            </div>
                        );
                    }

                    const fileExtension = props.filePath && props.filePath.toLowerCase().split('.').pop();
                    const unsupportedPreviewExtensions = ['csv', 'docx', 'xlsx', 'xls', 'doc', 'xlsm'];
                    const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];
                    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                    if (unsupportedPreviewExtensions.includes(fileExtension)) {
                        return (
                            <div className="xlx-file">
                                <img src={xlsxIcon} alt="XLSX Icon" />
                                <h5><b>Preview Not Available</b></h5>
                            </div>
                        );
                    }

                    if (fileExtension === 'pdf') {
                        return (
                            <div>
                                <iframe
                                    src={props.filePath}
                                    title="PDF Preview"
                                    width="100%"
                                    height="550"
                                    style={{ border: 'none' }}
                                ></iframe>
                            </div>
                        );
                    }

                    if (imageExtensions.includes(fileExtension)) {
                        return (
                            <div className="text-center">
                                <img src={props.filePath} alt="Preview" style={{ maxWidth: '100%', maxHeight: '550px' }} />
                            </div>
                        );
                    }

                   

                    return (
                        <div className="xlx-file">
                            <img src={xlsxIcon} alt="XLSX Icon" />
                            <h5><b>Preview Not Available</b></h5>
                        </div>
                    );

                })()}
            </Col>
            <Col md={5} >
            <ReactQuill
                    theme={'snow'}
                    modules={Editor.modules}
                    formats={Editor.formats}
                    value={props.note}
                    onChange={handleQuillChange}
                    bounds={'.quill-prod'}
                    placeholder='Add Your Comments Here'/>
            <div className="d-flex justify-content-end mt-2">
                <Button
                    className="btn-background-color"
                    onClick={props.addCMAssetChats}
                    disabled={!props.note}
                >
                    Add Note
                </Button>
            </div>
            <div className="comment-card">
             {  props.action? 
             <div className="comments-box scrollable-div p-0 overflow-auto mt-2">
                    {(props.noteList || []).length > 0 ?
                        props.noteList.map((noteItem) => (
                            <div key={noteItem.id || noteItem.createdAt}>
                                <div className={`d-flex ${noteItem.loggedInUser === 1 ? 'justify-content-end' : 'justify-content-start'} p-2`}>
                                    {props.selectedFileObject.loggedInUser !== noteItem.createdBy ?
                                        <div className="p-1 user-short-name">{noteItem.userShortName.toUpperCase()}</div> : ''}
                                    <p className={`p-2 mb-0 ${noteItem.loggedInUser === 1 ? 'chat-background-color-sent' : 'chat-background-color'}`}>
                                        <ReadMore htmlContent={noteItem.message} maxLength={200}
                                        onReadMoreClick={openNoteModal} />
                                        <span className="float-right">
                                            {new Date(noteItem.createdAt).toLocaleString()}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        )):  <p className="text-muted px-2 mt-3">No Comments</p>
                    }
                </div>: 
                <div className="comments-box scrollable-div p-0 overflow-auto">
                    {(props.noteList || []).length > 0 ?
                        props.noteList.map((noteItem) => (
                            <div key={noteItem.id }>
                                <div className={`d-flex ${noteItem.loggedInUser === 1 ? 'justify-content-end' : 'justify-content-start'} p-2`}>
                                    {props.selectedFileObject.loggedInUser !== noteItem.submittedBy ?
                                        <div className="p-1 user-short-name">{noteItem.userShortName.toUpperCase()}</div> : ''}
                                    <p className={`p-2 mb-0 ${noteItem.loggedInUser === 1 ? 'chat-background-color-sent' : 'chat-background-color'}`}>
                                        <ReadMore htmlContent={noteItem.notes} maxLength={200}
                                        onReadMoreClick={openNoteModal} />
                                        <span className="float-right">
                                            {new Date(noteItem.submittedOn).toLocaleString()}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        )):  <p className="text-muted px-2 mt-3">No Comments</p>
                    }
                </div>}
                </div>
            </Col>  
        </Row>
        <CustomModal
                header={"Comment"}
                isOpen={isExpanded}
                toggle={() => setIsExpanded(!isExpanded)}
                size={"xl"}
                className="curve-popup"
              >
                <p style={{ fontSize: "19px" }} className="issue-discription-set" dangerouslySetInnerHTML={{ __html: expandedNote || '' }} />
                {/* <Label>{ticketHistoryText}</Label> */}
            </CustomModal>
        </Card>
        
    )
}

export default AssetsCommentsPopup
